import React, { FC } from 'react'

import { useHistory } from 'react-router'

const Footer: FC = () => {
  const currentYear = new Date().getFullYear();
  const companyName = "Falcon-X";

  const history = useHistory()
  // <!-- start: FOOTER -->
  const toPrivacyStatement = (e: any) => {
    try {
      e.preventDefault()
      history.push('/privacystatement')
    } catch (e) { console.log(e) }
  }

  const toRequestContact = (e: any) => {
    try {
      e.preventDefault()
      history.push('/requestcontact')
    } catch (e) { console.log(e) }
  }
  return (
    <footer className="footer">
      <div className="container">
        {/* <!-- top footer statrs --> */}
        <div className="row top-footer">
          <div className="col-xs-12 col-sm-3 footer-logo-block color-gray">
            <a href="#" onClick={(e) => e.preventDefault()}>
              {' '}
              <img src="images/logo.png" width="60" height="50" alt="Footer logo" />{' '}
            </a>{' '}
            <h5 translate="no">Happy Order</h5>{' '}
          </div>
          <div className="col-xs-12 col-sm-9 about color-gray">
            <h5>Over ons</h5>
            <p>
              Happy Order is een online bestelplatform waarmee handelaars hun producten online kunnen
              aanbieden aan een zeer voordelig tarief.
            </p>
          </div>
        </div>
        {/* <!-- top footer ends -->
                <!-- bottom footer statrs --> */}
        <div className="bottom-footer">
          <div className="row">
            <div className="col-xs-12 col-sm-3 payment-options color-gray">
              <h5>Betalingsmogelijkheden</h5>
              <ul>
                <li>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {' '}
                    <img src="images/paypal.png" alt="Paypal" />{' '}
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {' '}
                    <img src="images/mastercard.png" alt="Mastercard" />{' '}
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {' '}
                    <img src="images/maestro.png" alt="Maestro" />{' '}
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {' '}
                    <img src="images/stripe.png" alt="Stripe" />{' '}
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    {' '}
                    <img src="images/bitcoin.png" alt="Bitcoin" />{' '}
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-4 address color-gray">
              <h5>Handelaar?</h5>
              <p>
                Ontdek de eenvoud van Happy Order! Klaar om jouw bestelproces te optimaliseren?
                <a onClick={toRequestContact} style={{ cursor: 'pointer', color: 'red' }}>
                  Neem een kijkje en laat uw contact gegevens achter.
                </a><br />
                Of stuur ons direct een e-mail op{' '}
                <a href="mailto:info@happyorder.be">info@happyorder.be</a>.

              </p>
            </div>
            <div className="col-xs-12 col-sm-5 additional-info color-gray">
              <h5>Contact</h5>
              <p>
                <a href="mailto:info@happyorder.be">info@happyorder.be</a>
              </p>
            </div>
            <div className="col-xs-12 col-sm-5 additional-info color-gray">
              <h5>Privacybeleid</h5>
              <p><a onClick={toPrivacyStatement} style={{ cursor: 'pointer', color: 'red' }}>klik hier om ons privacybeleid te lezen</a></p>
            </div>
          </div>
          {/* Add the copyright notice here */}
          <div className="row">
            <div className="col-xs-12 text-center color-gray">
              <p>
                &copy; {new Date().getFullYear()} Falcon-X. All rights reserved.
              </p>
            </div>
          </div>
          {/* End of copyright notice */}
        </div>
        {/* <!-- bottom footer ends --> */}
      </div>
    </footer>
  )
}

export default Footer
